import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import type { DialogProps } from '@material-ui/core/Dialog';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';

export interface PartnerFooterModalProps extends Pick<DialogProps, 'open' | 'onClose'> {
  footerModalTitle?: string;
  footerModalContent?: string;
}

/**
 * Partner Footer modal.
 */
export const UnstyledPartnerFooterModal: FunctionComponent<PartnerFooterModalProps> = ({
  footerModalTitle,
  footerModalContent,
  ...props
}) => {
  return (
    <Dialog {...props} fullWidth maxWidth="sm">
      <Box display="flex" flexDirection="row" justifyContent="flex-end" m={1}>
        <IconButton
          aria-label="close"
          onClick={(evt) => {
            if (props.onClose) {
              props.onClose(evt, 'backdropClick');
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent>
        <Typography variant="h3">{footerModalTitle}</Typography>
        <Typography color="textSecondary" variant="body2">
          {footerModalContent}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export const PartnerFooterModal = styled(UnstyledPartnerFooterModal)`
  & .MuiDialogContent-root {
    padding: 0px 48px 48px 48px;
  }

  & .MuiPaper-rounded {
    border-radius: 10px;
  }

  & h3 {
    margin-bottom: 1.75rem;
  }

  & p {
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    margin-bottom: 2rem;
  }
`;
